import { useState } from 'react';
import { IoMdArrowRoundForward } from 'react-icons/io';
import Typography from '../../../components/Typography';
import Section from '../../../components/Section';
import Button from '../../../components/Button';
import Input from '../../../components/Input';
import Link from '../../../components/Link';
import Card from '../../../components/Card';
import styles from './Contact.module.scss';
import useRecaptcha from '../../../utils/useRecaptcha';
import { toast } from 'react-hot-toast';

const items = [
  {
    icon: require('../../../assets/socials/email.svg'),
    label: 'hello@informreviews.net',
    href: 'mailto:hello@informreviews.net',
  },
];

const initForm = {
  name: '',
  email: '',
  message: '',
};

function Contact() {
  const [isLoading, setIsLoading] = useState(false);
  const [form, setForm] = useState({ ...initForm });
  const { getToken } = useRecaptcha();

  const submitForm = async () => {
    setIsLoading(true);
    try {
      await toast.promise(
        fetch(`${process.env.REACT_APP_API_URL}/www/contact`, {
          headers: {
            'x-inform-recaptcha': await getToken('contact'),
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(form),
          method: 'POST',
        }).then((d) => {
          if (!d.ok) throw new Error();
        }),
        {
          success: 'Message sent!',
          error: 'Unable to send message. Please try again later',
          loading: 'Sending message...',
        },
      );
      setForm({ ...initForm });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Section id="contact" className={styles.container}>
      <Card
        className={styles.content}
        backgroundColor="background-2"
        padding="4.25rem 5.25rem"
      >
        <div className={styles.details}>
          <Typography textType="h2">Get in Touch!</Typography>
          <Typography textType="h4" textWeight="normal" as="p">
            A team member will get in contact with you as soon as possible
          </Typography>
          <ul className={styles.items}>
            {items.map((item, key) => {
              const Icon = item.icon.ReactComponent;
              return (
                <Typography
                  className={styles.item}
                  textType="p1"
                  key={key}
                  as="li"
                >
                  <Card
                    className={styles.icon}
                    backgroundColor="background-1"
                    padding="0.625rem"
                  >
                    <Icon width="30" height="30" />
                  </Card>
                  <Link
                    className={styles.link}
                    type="anchor"
                    to={item.href}
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    {item.label}
                  </Link>
                </Typography>
              );
            })}
          </ul>
        </div>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            submitForm();
            return false;
          }}
          className={styles.form}
        >
          <Input
            className={styles.input}
            inputProps={{
              placeholder: 'Enter your name',
              required: true,
            }}
            onChange={({ target }) =>
              setForm({
                ...form,
                name: target.value,
              })
            }
            value={form.name}
            label="Name"
            name="name"
          />
          <Input
            className={styles.input}
            inputProps={{
              placeholder: 'Enter your email address',
              type: 'email',
              required: true,
            }}
            onChange={({ target }) =>
              setForm({
                ...form,
                email: target.value,
              })
            }
            value={form.email}
            label="Email Address"
            name="email"
          />
          <Input
            className={styles.input}
            inputProps={{
              placeholder: 'Enter your message',
              type: 'textarea',
              required: true,
              rows: 5,
            }}
            onChange={({ target }) =>
              setForm({
                ...form,
                message: target.value,
              })
            }
            value={form.message}
            label="Message"
            name="message"
          />
          <Typography textColor="text-2" textType="p4" as="p">
            This site is protected by reCAPTCHA and the Google{' '}
            <a
              href="https://policies.google.com/privacy"
              target="_blank"
              rel="noreferrer noopener"
            >
              Privacy Policy
            </a>{' '}
            and{' '}
            <a
              href="https://policies.google.com/terms"
              rel="noreferrer noopener"
            >
              Terms of Service
            </a>{' '}
            apply.
          </Typography>
          <Button
            icon={{
              element: IoMdArrowRoundForward,
              placement: 'right',
            }}
            disabled={isLoading}
            className={styles.button}
            buttonColor="success"
            variant="solid"
          >
            Send Message
          </Button>
        </form>
      </Card>
    </Section>
  );
}

Contact.routeProps = {
  path: 'contact',
  priority: 0,
  label: 'Contact',
};
export default Contact;
